/**
 * useRecomputeWorkspace — Hybrid C Button.
 * Ruft recompute-workspace und wiederholt automatisch, solange
 * stale_remaining > 0 (umgeht fehlende async-Infra ohne HTTP-Timeout).
 */
import { useState, useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { recomputeWorkspace } from '@/lib/api/channel-readiness'

const MAX_PASSES = 50

export function useRecomputeWorkspace() {
  const qc = useQueryClient()
  const [isPending, setIsPending] = useState(false)

  const run = useCallback(async () => {
    setIsPending(true)
    try {
      for (let pass = 0; pass < MAX_PASSES; pass++) {
        const res = await recomputeWorkspace({ limit: 500 })
        if (!res.success || res.stale_remaining <= 0) break
      }
      await qc.invalidateQueries({ queryKey: ['products-kpi'] })
      await qc.invalidateQueries({ queryKey: ['readiness'] })
      await qc.invalidateQueries({ queryKey: ['readiness-summary'] })
      await qc.invalidateQueries({ queryKey: ['workspace-issues'] })
    } finally {
      setIsPending(false)
    }
  }, [qc])

  return { run, isPending }
}
